import React, { Component } from 'react';
import { StyleSheet, Text, View, ImageBackground, LayoutAnimation } from 'react-native';
import SizeUtil from '../../../utils/SizeUtil';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

const scrollBarItemHeight = SizeUtil.getSize(16);
const touchBackground = '#00BCD4';
const touchDownBGColor = '#FFFFFF';
const touchUpBGColor = baseColor.text2;

let absoluteY = -1;
let animatedItemHeight = SizeUtil.getSize(16);
let isShowAnimate = false;

interface Props {
    dataLists: any;
    absoluteStartY: number;
    isInland: boolean;

    scrollToLocation: (index: number) => void;
}
interface State {
    data: [];
    isLongPress: boolean;
    isTouchDown: boolean;
    touchIndex: number; // 右侧索引点击位置，默认-1位于最上方
    animatItemVisableIndex: number; // 当前动画Item可显示的index
    animatedItemHeight: number;
    isShowAnimate: boolean;
}

export default class IndexScrollBar extends Component<Props, State> {
    public scrollBarView: View;
    public lastIndex: number;

    public constructor(props: Props) {
        super(props);
        this.state = {
            data: [],
            isLongPress: false,
            isTouchDown: false,
            touchIndex: -2, // 右侧索引点击位置，默认-1位于最上方
            animatItemVisableIndex: -1, // 当前动画Item可显示的index
            animatedItemHeight: 14,
            isShowAnimate: false
        };
        this.responderGrant = this.responderGrant.bind(this);
        this.responderMove = this.responderMove.bind(this);
        this.responderRelease = this.responderRelease.bind(this);
        this.scrollSectionList = this.scrollSectionList.bind(this);
    }

    public render() {
        const sectionItem = Object.keys(this.props.dataLists).map((item, index) => {
            return (
                <View
                    style={{
                        width: scrollBarItemHeight + SizeUtil.getSize(4),
                        alignItems: 'flex-start'
                    }}
                    key={index}
                >
                    <View
                        style={{
                            width: scrollBarItemHeight,
                            height: scrollBarItemHeight,
                            borderRadius: scrollBarItemHeight / 2,
                            backgroundColor:
                                this.state.touchIndex === index ? touchBackground : 'transparent',
                            justifyContent: 'center'
                        }}
                    >
                        <Text
                            key={index}
                            style={[
                                styles.sectionItemStyle,
                                {
                                    color:
                                        this.state.touchIndex === index
                                            ? touchDownBGColor
                                            : touchUpBGColor,
                                    backgroundColor: 'transparent'
                                }
                            ]}
                        >
                            {index === 0 ? '#' : item}
                        </Text>
                    </View>
                </View>
            );
        });

        return (
            <View style={{ position: 'absolute', right: SizeUtil.getSize(3), top: 0 }}>
                <View
                    style={[
                        styles.sectionItemViewStyle,
                        { right: 0, paddingTop: this.props.absoluteStartY }
                    ]}
                    ref={(r) => {
                        this.scrollBarView = r;
                    }}
                    onLayout={() => {
                        if (absoluteY === -1) {
                            // 获取该View的绝对坐标（相对屏幕坐标）
                            this.scrollBarView.measure(
                                (frameX, frameY, frameWidth, frameHeight, pageX, pageY) => {
                                    absoluteY = pageY;
                                }
                            );
                        }
                    }}
                    onStartShouldSetResponder={() => true} // 在用户开始触摸的时候（手指刚刚接触屏幕的瞬间），是否愿意成为响应者？
                    onMoveShouldSetResponder={() => true} // :如果View不是响应者，那么在每一个触摸点开始移动（没有停下也没有离开屏幕）时再询问一次：是否愿意响应触摸交互呢？
                    onResponderGrant={(evt) => this.responderGrant(evt)} // View现在要开始响应触摸事件了。这也是需要做高亮的时候，使用户知道他到底点到了哪里
                    onResponderMove={(evt) => this.responderMove(evt)} // 用户正在屏幕上移动手指时（没有停下也没有离开屏幕）
                    onResponderRelease={(evt) => this.responderRelease(evt)} // 触摸操作结束时触发，比如"touchUp"（手指抬起离开屏幕）
                    onResponderTerminationRequest={() => false} // 有其他组件请求接替响应者，当前的View是否“放权”
                >
                    {sectionItem}
                </View>
                {this.sectionAnimation()}
            </View>
        );
    }

    /** 用户手指开始触摸 */
    public responderGrant(event: any) {
        let index = this._getCurrentIndex(event);
        this.lastIndex = index;
        this.scrollSectionList(index);
        this.setState({
            isTouchDown: true,
            touchIndex: index
        });
        animatedItemHeight = SizeUtil.getSize(49.3);
        isShowAnimate = true;
    }

    /** 用户手指在屏幕上移动手指，没有停下也没有离开 */
    public responderMove(event: any) {
        let index = this._getCurrentIndex(event);
        if (this.lastIndex !== index) {
            this.lastIndex = index;
            this.scrollSectionList(index);
            isShowAnimate = true;
            this.setState({
                isTouchDown: true,
                touchIndex: index
            });
            animatedItemHeight = SizeUtil.getSize(49.3);
        }
    }

    /* 用户手指离开屏幕 */
    public responderRelease(event: any) {
        setTimeout(() => {
            // LayoutAnimation.configureNext(LayoutAnimation.create(100,
            //     LayoutAnimation.Types.spring,
            //     LayoutAnimation.Properties.opacity));

            animatedItemHeight = SizeUtil.getSize(17);
            isShowAnimate = false;
            this.setState({
                isTouchDown: false,
                isLongPress: false,
                touchIndex: -2
            });
        }, 200);
    }

    /* 手指滑动，触发事件 */
    public scrollSectionList(index: number) {
        // const dataLists = Object.keys(this.props.dataLists);
        this.props.scrollToLocation && this.props.scrollToLocation(index);
        return index;
    }

    public _getCurrentIndex = (event: any) => {
        const touch = event.nativeEvent.touches[0];
        let relativeY = touch.pageY - absoluteY - this.props.absoluteStartY;
        let index =
            Math.floor(relativeY / scrollBarItemHeight) < 0
                ? 0
                : Math.floor(relativeY / scrollBarItemHeight);
        return index;
    };

    /**
     * 右侧索引对应动画展示列
     */
    public sectionAnimation() {
        const { touchIndex } = this.state;
        const { dataLists } = this.props;
        const _dataLists = Object.keys(dataLists);
        const sectionAnimationItem = _dataLists.map((item, index) => {
            return touchIndex === index && isShowAnimate ? (
                <ImageBackground
                    key={index}
                    style={{
                        width: animatedItemHeight * 1.2048,
                        marginTop: -13,
                        height: animatedItemHeight,
                        justifyContent: 'center'
                    }}
                    source={{
                        uri:
                            'https://s.qunarzz.com/cmn_city_select_rn/score/assets/0.0.1/tagAnimate.png'
                    }}
                >
                    <Text
                        style={{
                            color: '#FFFFFF',
                            backgroundColor: 'transparent',
                            textAlign: 'center',
                            marginRight: 10,
                            marginBottom: 0,
                            fontSize: (animatedItemHeight / scrollBarItemHeight) * 10
                        }}
                    >
                        {index === 0 ? '#' : item}
                    </Text>
                </ImageBackground>
            ) : (
                <View
                    style={{
                        width: scrollBarItemHeight,
                        height: scrollBarItemHeight,
                        backgroundColor: 'transparent'
                    }}
                    key={index}
                />
            );
        });

        return (
            <View
                style={[
                    styles.sectionItemViewStyle,
                    {
                        right: 0,
                        marginRight: SizeUtil.getSize(90),
                        paddingTop: this.props.absoluteStartY - 5
                    }
                ]}
            >
                {sectionAnimationItem}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    sectionItemViewStyle: {
        position: 'absolute',
        width: scrollBarItemHeight,
        top: 0
    },
    sectionItemStyle: {
        fontSize: 12,
        textAlign: 'center',
        alignItems: 'center'
    }
});
